"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLogo = styled_components_1.default.img `
  border-radius: 15px;
  height: 80px;
  width: 80px;
`;
